import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  readonly breakpoints = {
    mobile: '(max-width: 767px)',
    tablet: '(min-width: 768px) and (max-width: 992px)',
    desktop: '(min-width: 993px)',
  };

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  isMobile(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return window.matchMedia(this.breakpoints.mobile).matches;
    }
    return false;
  }

  isTablet(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return window.matchMedia(this.breakpoints.tablet).matches;
    }
    return false;
  }

  isDesktop(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      return window.matchMedia(this.breakpoints.desktop).matches;
    }
    return false;
  }
}
